var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAggressiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8507",
    transform: "translate(3 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8599",
    transform: "translate(-2.551 -47.551)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_364",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-0.449 -0.449)",
    fill: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4991",
    d: "M3270,334.785v10.46",
    transform: "translate(-3255.245 -321.311)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4993",
    d: "M3270,331.817v4.926",
    transform: "translate(-3259.861 -312.809)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4992",
    d: "M3270,331.817v17",
    transform: "translate(-3250.628 -324.883)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggressiveIcon);
export default __webpack_public_path__ + "static/media/aggressive_icon.7e5c6c47ae498169239d0b682ff48804.svg";
export { ForwardRef as ReactComponent };